import React, { useMemo, useState, useContext } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import useDetailFetch from '../../../../hooks/useDetailFetch';
import SingleItemDetailTemplate from '../../../Reusable_Components/SingleItemDetailTemplate';
import ConfirmModal from '../../../Reusable_Components/ConfirmModal';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/Config/apiConfig';
import { ToastContext } from '../../../../context/ToastContext';

const SingleOpportunityStageDetails = () => {
  const { stageId: id } = useParams();
  const navigate = useNavigate();
  const { showToast } = useContext(ToastContext);

  const decodedId = id ? atob(id) : id;
  const stageId = decodedId.replace(/\D/g, '');

  const [showDelete, setShowDelete] = useState(false);

  const url = stageId ? `${API_DOMAIN}${API_ROUTES.opportunityStage}${stageId}/` : null;
  const { data: details, loading } = useDetailFetch(url);

  const columns = useMemo(() => {
    if (!details) return null;
    const excluded = ['id', 'created_at', 'updated_at'];
    return Object.keys(details)
      .filter(c => !excluded.includes(c))
      .map(c => ({ label: c.charAt(0).toUpperCase() + c.slice(1).replace(/_/g, ' '), field: c }));
  }, [details]);

  const handleDelete = async () => {
    try {
      await axios.delete(`${API_DOMAIN}${API_ROUTES.opportunityStage}${stageId}/`, { headers });
      showToast('Opportunity stage deleted successfully', 'success');
      navigate('/opportunity/stage/list');
    } catch (error) {
      console.error('Error deleting opportunity stage:', error);
      showToast('Error deleting opportunity stage', 'error');
    }
  };

  return (
    <div>
      <SingleItemDetailTemplate
        details={details}
        columns={columns}
        loading={loading}
        entityName="Opportunity Stage"
        listPath="/opportunity/stage/list"
        editPath={`/opportunity/stage/input/${btoa(stageId)}`}
        onDelete={() => setShowDelete(true)}
      />
      <ConfirmModal
        isOpen={showDelete}
        title="Delete Opportunity Stage"
        message="Are you sure you want to delete this opportunity stage?"
        onConfirm={handleDelete}
        onCancel={() => setShowDelete(false)}
      />
    </div>
  );
};

export default SingleOpportunityStageDetails;
